import { useState, useEffect } from 'react';

const PROXY_URL = (import.meta.env.VITE_PROXY_URL || 'http://localhost:4005').replace(/\/+$/, '');

function PosterTile({ item }) {
    const [loaded, setLoaded] = useState(false);
    const [errored, setErrored] = useState(false);

    return (
        <div className="flex-none rounded overflow-hidden" style={{ width: 110, aspectRatio: '2/3' }}>
            {item.posterPath && !errored ? (
                <img
                    src={item.posterPath}
                    alt=""
                    className={`w-full h-full object-contain transition-opacity duration-500 ${loaded ? 'opacity-100' : 'opacity-0'}`}
                    draggable={false}
                    onLoad={() => setLoaded(true)}
                    onError={() => setErrored(true)}
                />
            ) : (
                <div className="w-full h-full flex items-end p-2 bg-gradient-to-br from-bg-secondary to-bg-tertiary">
                    <span className="text-text-tertiary text-[10px] leading-tight line-clamp-3">{item.title}</span>
                </div>
            )}
        </div>
    );
}

function PosterRow({ items, duration, reverse }) {
    const looped = [...items, ...items];
    const dir = reverse ? 'bg-marquee-rev' : 'bg-marquee-fwd';
    return (
        <div className="overflow-hidden">
            <div className={`flex gap-3 ${dir}`} style={{ animationDuration: `${duration}s`, width: 'max-content' }}>
                {looped.map((item, i) => (
                    <PosterTile key={`${item.bggId}-${i}`} item={item} />
                ))}
            </div>
        </div>
    );
}

export default function TrendingSignInBackground() {
    const [items, setItems] = useState([]);

    useEffect(() => {
        fetch(`${PROXY_URL}/api/bgg/trending?limit=30`)
            .then(r => r.ok ? r.json() : [])
            .then(data => setItems(Array.isArray(data) ? data : []))
            .catch(() => {});
    }, []);

    if (!items.length) return <div className="absolute inset-0 bg-bg-primary" />;

    const third = Math.ceil(items.length / 3);
    const rows = [items.slice(0, third), items.slice(third, third * 2), items.slice(third * 2)];

    return (
        <>
            <style>{`
                @keyframes bg-marquee-fwd { from { transform: translateX(0); } to { transform: translateX(-50%); } }
                @keyframes bg-marquee-rev { from { transform: translateX(-50%); } to { transform: translateX(0); } }
                .bg-marquee-fwd { animation: bg-marquee-fwd linear infinite; }
                .bg-marquee-rev { animation: bg-marquee-rev linear infinite; }
            `}</style>
            <div className="absolute inset-0 flex flex-col justify-center gap-3 py-8 pointer-events-none select-none">
                <PosterRow items={rows[0]} duration={50} reverse={false} />
                <PosterRow items={rows[1]} duration={65} reverse={true} />
                <PosterRow items={rows[2]} duration={45} reverse={false} />
            </div>
            <div className="absolute inset-0 bg-black/60 backdrop-blur-[2px]" />
        </>
    );
}
